import operations from '~/helpers/device-operations';
import { BehaviorKey, Operation } from '~/interfaces/device.interface';
import { FieldObject } from '~/interfaces/field.interface';
import { Gateway } from '~/models/gateways/gateway.model';
import { getServerNodeFields } from '~/models/helpers/network.function';

export class ELG extends Gateway {
    behaviorFields: BehaviorKey[] = [
        'rf_statistics_enabled',
    ];

    get deviceOperations(): Operation[] {
        return super.deviceOperations.concat([
            operations.switchDatabase({
                callback: this.switchDatabase,
                disabled: this.isSwitchDatabaseDisabled,
            }),
            operations.dump({ callback: this.dump }),
            operations.orderReboot({ callback: this.orderReboot, disabled: this.isOrderRebootDisabled }),
            operations.setDump({ callback: this.setDump }),
        ]);
    }

    get fieldName() {
        return undefined;
    }

    get fieldLastSetup() {
        return undefined;
    }


    getNetworkFields(): FieldObject[] {
        let fields = super.getNetworkFields();
        if (this.network) {
            fields = fields.concat(getServerNodeFields(this.network.server_node));
        }
        return fields;
    }

}
